//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";

export default {
  name: "LabelsDialog",
  components: {},
  props: [],
  mounted: function () {},
  data: function () {
    return {
      batatas: true,
      products: [],
      stores: [],
    };
  },
  methods: {},
  computed: {
    drawerProductHierarchy: function () {
      return this.$store.getters.getHierarchyLevelElementLabels.product
        .concat(this.products.join(", "))
        .filter((i) => i.length > 0)
        .join(" >> ");
    },
    drawerStoreHierarchy: function () {
      return this.$store.getters.getHierarchyLevelElementLabels.store
        .concat(this.stores.join(", "))
        .filter((i) => i.length > 0)
        .join(" >> ");
    },
    drawerGeographyHierarchy: function () {
      return this.$store.getters.getHierarchyLevelElementLabels.geography
        .filter((i) => i.length > 0)
        .join(" >> ");
    },
  },
  watch: {
    "$store.getters.getProductList": {
      immediate: true,
      deep: true,
      handler: function () {
        this.products = [];
        let productList = this.$store.getters.getProductList;
        productList.forEach((productId) => {
          BackendServices.getProduct(productId).then((response) => {
            let i = response.data;
            this.products.push(`${i.name} (${i.ean})`);
          });
        });
      },
    },
    "$store.getters.getStoreList": {
      immediate: true,
      deep: true,
      handler: function () {
        this.stores = [];
        let storeList = this.$store.getters.getStoreList;
        storeList.forEach((storeId) => {
          BackendServices.getStore(storeId).then((response) => {
            let i = response.data;
            this.stores.push(`${i.code} - ${i.name}`);
          });
        });
      },
    },
  },
};
